import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersDetailSubjectType} from "../interface";
import {updateShipmentExchangeRate} from "../../../../../api/order/OrdersApi";
import {useSetAtom} from "jotai/index";
import {isLoading} from "../../../../../state/Spinner";

export const useUpdateShipmentExchangeRate = () => {
    const setLoading = useSetAtom(isLoading);

    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OrdersDetailSubjectType) => updateShipmentExchangeRate(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
        onMutate: () => setLoading(true),
        onSettled: () => setLoading(false)
    });

    return {mutate, mutateAsync};
};
